import { Check } from '@insify/design-system/icons';
import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import styles from './TopUSP.module.css';

const TopUSP = ({ children }: { children?: React.ReactNode }) => <div className={styles.topUSP}>{children}</div>;

TopUSP.Check = () => <Check className={styles.check} />;

TopUSP.TextWithStrong = ({ children }: { children: React.ReactNode }) => (
  <span className={clsx(textSm, styles.text)}>{children}</span>
);

export { TopUSP };
